/** English strings */
export const EN: Record<string, string> = {
  'ui.confirm': 'OK',
  'ui.cancel': 'Cancel',
  'ui.close': 'Close',
  'ui.back': 'Back',
  'ui.level': 'Level',
  'ui.coins': 'Coins',
  'ui.food': 'Food',
  'ui.energy': 'Energy',
  'ui.reputation': 'Fame',
  'ui.xp': 'XP',
  'ui.owned': 'Owned',
  'ui.locked': 'Locked',
  'ui.lvRequire': 'Unlocks at Lv.{lv}',
  'ui.buy': 'Buy',
  'ui.sell': 'Sell',
  'ui.sellAll': 'Sell All',
  'ui.claim': 'Claim',
  'ui.free': 'Free',
  'ui.max': 'Max',
  'ui.new': 'New!',

  'start.title': 'Paradise Isle',
  'start.subtitle': 'Your home on the sea',
  'start.newGame': 'New Island',
  'start.continue': 'Continue',
  'start.namePrompt': 'Name your islander',
  'start.defaultName': 'Islander',
  'start.slotEmpty': 'Empty Slot',
  'start.delete': 'Delete',
  'start.deleteConfirm': 'Delete this save? This cannot be undone!',
  'start.tagline': 'Farm · Fish · Fight · Fashion · Friends',

  'hud.bag': 'Bag',
  'hud.shop': 'Shop',
  'hud.quests': 'Quests',
  'hud.collections': 'Dex',
  'hud.wardrobe': 'Dress',
  'hud.neighbors': 'Friends',
  'hud.edit': 'Decorate',
  'hud.settings': 'Settings',
  'hud.home': 'Home',
  'hud.energyFull': 'Energy full',
  'hud.nextEnergy': '+1 in {t}',

  'act.till': 'Till ({coins} coins)',
  'act.plant': 'Plant',
  'act.water': 'Water',
  'act.harvest': 'Harvest',
  'act.clear': 'Remove',
  'act.removePlot': 'Remove plot',
  'act.feed': 'Feed',
  'act.collect': 'Collect',
  'act.fight': 'Fight!',
  'act.fish': 'Fish',
  'act.weed': 'Clear weed',
  'act.pet.feed': 'Feed (5 food)',
  'act.pet.play': 'Play',
  'act.chase': 'Chase away',
  'act.helpWater': 'Help water',
  'act.prank': 'Prank',

  'panel.inventory': 'Bag',
  'panel.shop': 'Island Shop',
  'panel.quests': 'Quest Log',
  'panel.achievements': 'Achievements',
  'panel.daily': 'Daily Quests',
  'panel.tutorial': 'Islander Guide',
  'panel.collections': 'Collections',
  'panel.fishdex': 'Fish Dex',
  'panel.beastdex': 'Beast Dex',
  'panel.wardrobe': 'Wardrobe',
  'panel.neighbors': 'Neighbors',
  'panel.settings': 'Settings',
  'panel.offline': 'While you were away…',

  'shop.seeds': 'Seeds',
  'shop.trees': 'Trees',
  'shop.animals': 'Animals',
  'shop.buildings': 'Build',
  'shop.clothing': 'Clothing',
  'shop.pets': 'Pets',
  'shop.tools': 'Tools',
  'shop.expand': 'Expand Island',
  'shop.expandDesc': 'Grow to {size}×{size} (needs Lv.{lv})',
  'shop.rod': 'Rod Upgrade',
  'shop.rodT1': 'Bamboo Rod',
  'shop.rodT2': 'Fiberglass Rod',
  'shop.rodT3': 'Carbon Master Rod',
  'shop.rodDesc': 'Better rods catch rarer fish',
  'shop.grow': 'Grows in {t}',
  'shop.produce': 'Produces every {t}',
  'shop.feedCost': 'Feed costs {n} food',
  'shop.beauty': 'Beauty +{n}',
  'shop.adoptName': 'Give it a name:',

  'inv.empty': 'Your bag is empty — go harvest something!',
  'inv.sellFor': '{n} coins each',

  'quest.done': 'Done',
  'quest.progress': 'In progress',
  'quest.reward': 'Reward',
  'quest.dailyRefresh': 'Refreshes at midnight',
  'quest.noneActive': 'No active quests right now',

  'dex.caught': 'Collected {a}/{b}',
  'dex.unknown': '???',
  'dex.beastNote': 'Defeat beasts to unlock entries',

  'wd.skin': 'Skin',
  'wd.hair': 'Hair',
  'wd.face': 'Face',
  'wd.top': 'Top',
  'wd.bottom': 'Bottom',
  'wd.hat': 'Hat',
  'wd.accessory': 'Accessory',
  'wd.takeOff': 'Take off',

  'nb.friendship': 'Friendship',
  'nb.visit': 'Visit',
  'nb.hire': 'Hire ({coins} coins)',
  'nb.hireDesc': 'They will water, weed, and chase beasts for you',
  'nb.helpLeft': '{n} helps left today',
  'nb.prankLeft': '{n} pranks left',
  'nb.friendCode': 'Friend Code',
  'nb.myCode': 'Copy my island code',
  'nb.visitCode': 'Paste a friend code',
  'nb.codeCopied': 'Island code copied — share it!',
  'nb.codePrompt': "Paste your friend's island code:",
  'nb.codeBad': "Couldn't read that island code…",
  'nb.visiting': "Visiting {name}'s island",
  'nb.snapshotNote': "A snapshot of {name}'s island",

  'fish.cast': 'Cast',
  'fish.wait': 'Waiting for a bite…',
  'fish.bite': 'Bite! Click!',
  'fish.reel': 'Tap to reel! Stay in the green!',
  'fish.escaped': 'It got away…',
  'fish.caught': 'Caught {name}!',
  'fish.newRecord': 'New dex entry!',

  'battle.title': 'Drive off the {name}!',
  'battle.hint': 'Click when the pointer is in the green zone!',
  'battle.hit': 'Hit!',
  'battle.crit': 'Critical!!',
  'battle.miss': 'Miss… it fought back!',
  'battle.win': 'Success! Got {coins} coins',
  'battle.flee': 'Retreat',

  'set.lang': '语言 Language',
  'set.sound': 'Sound FX',
  'set.music': 'Music',
  'set.export': 'Export save',
  'set.import': 'Import save',
  'set.exportDone': 'Save copied to clipboard',
  'set.importPrompt': 'Paste save data:',
  'set.importBad': 'Invalid save data',
  'set.importDone': 'Imported!',
  'set.reset': 'Back to title',
  'set.about': 'About',

  'off.title': 'Welcome back, {name}!',
  'off.away': 'You were away for {t}',
  'off.crops': '{n} crops are ready',
  'off.animals': '{n} animals have produce ready',
  'off.beasts': '{n} beasts invaded your island!',
  'off.weeds': '{n} weeds sprouted',
  'off.trampled': '{n} crops were trampled…',
  'off.energy': 'Energy restored by {n}',
  'off.gift': 'Your pet brought a gift: {name}',

  'tut.hint': 'Current quest',

  'msg.noEnergy': 'Not enough energy! Rest or level up',
  'msg.noCoins': 'Not enough coins',
  'msg.noFood': 'Not enough food — harvest some crops',
  'msg.noSeed': 'No seeds of this kind — buy some at the shop',
  'msg.noSpace': 'No free space on the island',
  'msg.needGrass': 'Can only till grass',
  'msg.occupied': 'That spot is taken',
  'msg.weedHere': 'Clear the weed first',
  'msg.noPlot': 'No plot here',
  'msg.plotBusy': 'This plot is already planted',
  'msg.noCrop': 'This plot is empty',
  'msg.noNeedWater': 'No need to water now',
  'msg.waterCd': 'Just watered — give it a moment',
  'msg.notReady': 'Not ready yet',
  'msg.notFound': 'Target not found',
  'msg.notHungry': "It isn't hungry",
  'msg.locked': 'Not unlocked yet',
  'msg.owned': 'Already owned',
  'msg.notOwned': "You don't own this",
  'msg.cannotPlace': "Can't place here",
  'msg.cannotSell': "This can't be sold",
  'msg.notEnough': 'Not enough',
  'msg.maxRod': 'Rod is already maxed',
  'msg.maxIsland': 'Island is at max size',
  'msg.helpLimit': 'No more helps here today',
  'msg.prankLimit': 'No more pranks here today',
  'msg.allClaimed': 'All rewards claimed',
  'msg.cleared': 'Cleared',
  'msg.animalBought': 'A new friend moved in!',
  'msg.rodUpgraded': 'Rod upgraded!',
  'msg.questReady': 'A quest is ready to turn in!',
  'msg.friendGift': 'Friendship up! {name} gave you {n} coins',
  'msg.hireDone': 'Your neighbor did {n} chores',
  'msg.levelUp': 'Level {lv}! Energy fully restored!',
  'msg.saved': 'Saved',
  'msg.achievement': 'Achievement: {name} tier {tier}',
  'msg.beastArrive': 'A beast is invading the island!',
  'msg.petGift': '{pet} brought back {item}!',
  'msg.expanded': 'Island expanded!',
};
